var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "UserBalanceInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "inBill",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "outDiamond",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "bill",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "diamond",
                    "id": 4
                }
            ]
        },
        {
            "name": "LiveDetailInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "onlineTotal",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "roomTitle",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "liveMsg",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "qualityAuth",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "double",
                    "name": "distance",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "distanceStr",
                    "id": 18
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "bigAvatar",
                    "id": 19
                },
                {
                    "rule": "optional",
                    "type": "LiveType",
                    "name": "liveType",
                    "id": 20
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "enterNeedDiamond",
                    "id": 21
                },
                {
                    "rule": "repeated",
                    "type": "LiveLabel",
                    "name": "liveLabels",
                    "id": 22
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "voiceFlag",
                    "id": 23
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ab",
                    "id": 24
                }
            ]
        },
        {
            "name": "LiveLabel",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "labelName",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "labelValue",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ext",
                    "id": 3
                }
            ]
        },
        {
            "name": "ProfileInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "setting",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "password",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "userToken",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "mobilePhone",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "fanTotal",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followTotal",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "UserBalanceInfo",
                    "name": "balance",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "chatroomid",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followType",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "exp",
                    "id": 18
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "currentExp",
                    "id": 19
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "nextExp",
                    "id": 20
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 21
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 22
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "qualityAuth",
                    "id": 23
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 25
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "admin",
                    "id": 26
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "userRealNameAuth",
                    "id": 27
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "acceptAgreement",
                    "id": 28
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "upliveCodeStatus",
                    "id": 29
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "subscribe",
                    "id": 30
                },
                {
                    "rule": "repeated",
                    "type": "Source",
                    "name": "sources",
                    "id": 31
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "dynamicCount",
                    "id": 32
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "dynamicPublishRight",
                    "id": 33
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "liveType",
                    "id": 34
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "enterNeedDiamond",
                    "id": 35
                },
                {
                    "rule": "repeated",
                    "type": "LiveLabel",
                    "name": "liveLabels",
                    "id": 36
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ipForCountry",
                    "id": 37
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "dynamicManageRights",
                    "id": 38
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "newUserDueTime",
                    "id": 39
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "newUser",
                    "id": 40
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "hostStatus",
                    "id": 41
                }
            ]
        },
        {
            "name": "Source",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "bindType",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "openId",
                    "id": 2
                }
            ]
        },
        {
            "name": "LabelInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "label",
                    "id": 1
                }
            ]
        },
        {
            "name": "PermissionInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "permission",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "leftover",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "recoveryTime",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "keepTime",
                    "id": 4
                }
            ]
        },
        {
            "name": "Mall",
            "fields": [],
            "options": {
                "objc_class_prefix": "MallMountInfo",
                "java_package": "com.asiainno.uplive.proto"
            },
            "messages": [
                {
                    "name": "MountInfo",
                    "fields": [
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "mountId",
                            "id": 1
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "name",
                            "id": 2
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "intro",
                            "id": 3
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "price",
                            "id": 4
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "timeUnit",
                            "id": 5
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "experience",
                            "id": 6
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "version",
                            "id": 7
                        },
                        {
                            "rule": "optional",
                            "type": "bool",
                            "name": "onLined",
                            "id": 8
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "countryCode",
                            "id": 9
                        },
                        {
                            "rule": "optional",
                            "type": "bool",
                            "name": "needLoad",
                            "id": 10
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "vipGrade",
                            "id": 11
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "playTimes",
                            "id": 12
                        },
                        {
                            "rule": "repeated",
                            "type": "MountResourceInfo",
                            "name": "resources",
                            "id": 13
                        },
                        {
                            "rule": "repeated",
                            "type": "MountPriceConfig",
                            "name": "prices",
                            "id": 14
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "originalPrice",
                            "id": 15
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "discountType",
                            "id": 16
                        },
                        {
                            "rule": "optional",
                            "type": "float",
                            "name": "discountValue",
                            "id": 17
                        }
                    ]
                },
                {
                    "name": "MountResourceInfo",
                    "fields": [
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "type",
                            "id": 1
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "url",
                            "id": 2
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "md5",
                            "id": 3
                        }
                    ]
                },
                {
                    "name": "MountPriceConfig",
                    "fields": [
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "id",
                            "id": 1
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "price",
                            "id": 2
                        },
                        {
                            "rule": "optional",
                            "type": "string",
                            "name": "timeUnit",
                            "id": 3
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "originalPrice",
                            "id": 4
                        },
                        {
                            "rule": "optional",
                            "type": "int32",
                            "name": "discountType",
                            "id": 5
                        },
                        {
                            "rule": "optional",
                            "type": "float",
                            "name": "discountValue",
                            "id": 6
                        }
                    ]
                }
            ]
        },
        {
            "name": "Profile",
            "fields": [],
            "messages": [
                {
                    "name": "Get",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "ProfileGet",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "vuid",
                                    "id": 1
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "ProfileInfo",
                                    "name": "profile",
                                    "id": 1
                                },
                                {
                                    "rule": "repeated",
                                    "type": "LabelInfo",
                                    "name": "userLabels",
                                    "id": 2
                                },
                                {
                                    "rule": "repeated",
                                    "type": "PermissionInfo",
                                    "name": "canPermissions",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "Mall.MountInfo",
                                    "name": "mountInfo",
                                    "id": 4
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "BindType",
            "values": [
                {
                    "name": "DEFAULT_TYPE",
                    "id": 0
                },
                {
                    "name": "MOBILE_PHONE",
                    "id": 1
                },
                {
                    "name": "QQ",
                    "id": 2
                },
                {
                    "name": "WEIXIN",
                    "id": 3
                },
                {
                    "name": "FACEBOOK",
                    "id": 4
                },
                {
                    "name": "SINA_WEIBO",
                    "id": 5
                },
                {
                    "name": "RR",
                    "id": 6
                },
                {
                    "name": "TENCENT_WANBA",
                    "id": 7
                },
                {
                    "name": "KECHENGGEZI",
                    "id": 8
                },
                {
                    "name": "DEVICE",
                    "id": 9
                },
                {
                    "name": "GOOGLE",
                    "id": 15
                },
                {
                    "name": "TWITTER",
                    "id": 16
                },
                {
                    "name": "EMAIL",
                    "id": 17
                },
                {
                    "name": "LINE_BIND",
                    "id": 19
                }
            ]
        },
        {
            "name": "PushType",
            "values": [
                {
                    "name": "DEFAULT_PUSHTYPE",
                    "id": 0
                },
                {
                    "name": "BAIDU",
                    "id": 1
                },
                {
                    "name": "IOS",
                    "id": 2
                },
                {
                    "name": "JPUSH",
                    "id": 3
                },
                {
                    "name": "XIAOMI",
                    "id": 4
                },
                {
                    "name": "GETUI",
                    "id": 5
                },
                {
                    "name": "GOOGLE_PUSH",
                    "id": 6
                },
                {
                    "name": "SAMSUNG",
                    "id": 7
                },
                {
                    "name": "MEIZU",
                    "id": 8
                },
                {
                    "name": "HUAWEI",
                    "id": 9
                },
                {
                    "name": "GOOGLE_FCM",
                    "id": 10
                }
            ]
        },
        {
            "name": "LiveType",
            "values": [
                {
                    "name": "PUBLIC_FREE",
                    "id": 0
                },
                {
                    "name": "PUBLIC_CHARGE",
                    "id": 1
                },
                {
                    "name": "PRIVATE_FREE",
                    "id": 2
                },
                {
                    "name": "PRIVATE_CHARGE",
                    "id": 3
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/profile/index.pb.js